import { getAPIHeaders } from '@/services/api.service';

export async function getLastSynthesesExport(projectId) {
    const response = await fetch(`/api/projects/${projectId}/SynthesesExports`, {
        headers: getAPIHeaders(),
    });
    return (await response.json()).pop();
}
export async function getSynthesesExport(projectId, SynthesesExportId) {
    const response = await fetch(`/api/projects/${projectId}/SynthesesExports/${SynthesesExportId}`, {
        headers: getAPIHeaders(),
    });
    return await response.json();
}

export async function createSynthesesExport(projectId, SynthesesExport) {
    const response = await fetch(
        new Request(`/api/projects/${projectId}/SynthesesExports`, {
            method: 'POST',
            headers: getAPIHeaders({ 'content-type': `application/json` }),
            body: JSON.stringify(SynthesesExport),
        }),
    );
    if (response && response.ok) {
        return response.json();
    } else {
        throw new Error('Syntheses Exports failed');
    }
}
